/**
 * Enum loại phân bổ ctx
 */
export default {
  /**
   * None
   */
  None: 0,
  /**
   * CTX
   */
  Regular: 1,
  /**
   * CTMT
   */
  Project: 2,
  /**
   * Lĩnh vực
   */
  Field: 3,
  /**
   * Nguồn kinh phí
   */
  Source: 4,
  /**
   * Tổng cộng
   */
  Total: 5,
  /**
   * Nhóm tiêu chí
   */
  CriteriaGroup: 6,
};
